import { useState, useEffect } from "react";
import { useGlobalContext } from "../GlobalContext";
import TransaksiUmum from "./report/pdf/transaksiumum";

const TransaksiUspUmum = () => {
  const tglSekarang = new Date();
  const tglSekarangString = tglSekarang.toISOString().split(`T`)[0];
  const { periode, api, kode } = useGlobalContext();
  const [formData, setFormData] = useState({
    tanggal: tglSekarangString,
    noTransaksi: "",
    tglproses: "",
    noAnggota: "",
    nama: "",
    unitkerja: "",
    kdunitkerja: "",
    sapokok: 0,
    sawajib: 0,
    samanasuka: 0,
    sahariraya: 0,
    savoucher: 0,
    pokok: 0,
    wajib: 0,
    manasuka: 0,
    hariraya: 0,
    voucher: 0,
    saldo: 0,
    kdtrans: "1",
    saldoawl: 0,
    notran_shmref: "",
    noTransaksiUmum: "",
    noTransPiutang: {
      unitD:"",
      unitC:"",
      unitA:"",
    },
    sisaPiutang: {
      unitD: 0,
      unitC: 0,
      unitA: 0,
    },
    totalJasa: {
      unitD: 0,
      unitC: 0,
      unitA: 0,
    },
    totalGermen: {
      unitD: 0,
      unitC: 0,
      unitA: 0,
    },
    angsuran: {
      unitD: 0,
      unitC: 0,
      unitA: 0,
    },
    jasa: {
      unitD: 0,
      unitC: 0,
      unitA: 0,
    },
    germen: {
      unitD: 0,
      unitC: 0,
      unitA: 0,
    },
    total: "",
  });

  const resetFormData = {
    noAnggota: "",
    nama: "",
    unitkerja: "",
    sapokok: "0",
    sawajib: "0",
    samanasuka: "0",
    sahariraya: 0,
    savoucher: 0,
    pokok: "0",
    wajib: "0",
    manasuka: "0",
    hariraya: 0,
    voucher: 0,
    jenissimp: "",
    noTransPiutang: {
      unitD:"",
      unitC:"",
      unitA:"",
    },
    sisaPiutang: {
      unitD: "0",
      unitC: "0",
      unitA: "0",
    },
    totalJasa: {
      unitD: "0",
      unitC: "0",
      unitA: "0",
    },
    totalGermen: {
      unitD: "0",
      unitC: "0",
      unitA: "0",
    },
    angsuran: {
      unitD: "0",
      unitC: "0",
      unitA: "0",
    },
    jasa: {
      unitD: "0",
      unitC: "0",
      unitA: "0",
    },
    germen: {
      unitD: "0",
      unitC: "0",
      unitA: "0",
    },
    total: "",
  };

  const dataSimpUSP = {
    tanggal: "",
    notransaksi: "",
    noanggota: "",
    nama: "",
    sapokok: "0",
    sawajib: "0",
    spokok: "0",
    swajib: "0",
    postagihan: "1",
  };

  const dataSimpManasuka = {
    notransaksi: "",
    tgltransak: "",
    noanggota: "",
    jenissimp: "1",
    kdtrans: "1",
    debet: "0",
    kredit: "0",
    saldoawl: "0",
    saldo: "0",
  };

  const dataSimpHariRaya = {
    notransaksi: "",
    tgltransak: "",
    noanggota: "",
    jenissimp: "1",
    kdtrans: "1",
    debet: "0",
    kredit: "0",
    saldoawl: "0",
    saldo: "0",
  };

  const dataSimpVoucher = {
    notransaksi: "",
    tgltransak: "",
    noanggota: "",
    kdtrans: "1",
    debet: "0",
    kredit: "0",
    tglproses: "",
    notransumum: "",
  };

  const dataAngsuran = {
    tanggal: "",
    notransaksi: "",
    noanggota: "",
    nama: "",
    postagihan: "",
    sa_angsuran_d: "0",
    sa_angsuran_c: "0",
    sa_angsuran_a: "0",
    angsuran_d: "0",
    angsuran_c: "0",
    angsuran_a: "0",
    jasa_d: "0",
    jasa_c: "0",
    jasa_a: "0",
    germen_d: "0",
    germen_c: "0",
    germen_a: "0",
  };

  const [total, setTotal] = useState({
    angsuran: 0,
    jasa: 0,
    germen: 0,
    keseluruhan: 0,
  });

  const [prevNoAnggota, setPrevNoAnggota] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;


    setFormData((prev) => {
      if (type === "date") {
         return{...prev, [name]: value };
      } 
      const numericValue = value.replace(/\D/g, "");
      if (name.includes(".")) {
        const [field, unit] = name.split(".");

        return {
          ...prev,
          [field]: {
            ...prev[field],
            [unit]: numericValue,
          },
        };
      } else {
        // Field biasa
        return{
          ...prev,
          [name]: numericValue,
        };
      }
    });
  };


  // Fungsi untuk menambahkan titik sebagai pemisah ribuan
  const parseNumber = (value) => {
    if (!value) return 0;
    const normalized = String(value).replace(/\./g, "").replace(",", ".");
    return Number(normalized) || 0;
  };

  const formatNumber = (number) => {
    if (!number && number !== 0) return "0";
    const num = typeof number === "string" ? parseInt(number) : number;
    if (isNaN(num)) return "0";
    return num.toLocaleString("id-ID"); // Format angka dengan separator ribuan
  };  

  //Generated Untuk Umum
  const GenereateNoTransUmum = async () => {
    const noawal = periode.toString(); 
    const notransaksiwal = noawal.substring(2, 6); // contoh: 2508

    try {
      const response = await api.get(`/api/transaksi/getnotransaksiumum/${notransaksiwal}`);
      if (response.status === 200) {
        let lastTrans = response.data.notransaksi
          ? response.data.notransaksi.toString()
          : "";

        // Ambil index transaksi, pastikan ada 6 digit di belakang prefix
        let noindektrans =
          lastTrans.length >= 10 ? lastTrans.substring(4, 10) : "000000";

        // tambah 1 dari nomor terakhir
        let noindextransnext = (parseInt(noindektrans) || 0) + 1;

        // bentuk nomor transaksi baru
        const notransaksi =
          notransaksiwal + noindextransnext.toString().padStart(6, "0");

        setFormData((prevData) => ({
          ...prevData,
          noTransaksi: notransaksi,
        }));

        return notransaksi;
      } else {
        alert("Unexpected response status");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          // Kalau belum ada transaksi sama sekali, mulai dari 1
          const notransaksi = notransaksiwal + "000001";
          setFormData((prevData) => ({
            ...prevData,
            noTransaksi: notransaksi,
          }));
          return notransaksi;
        } else {
          alert(`Error: ${error.response.status}`);
        }
      } else {
        alert("An unexpected error occurred");
      }
    }
    return null;
  };

  // === Generate No Transaksi Simpanan USP ===
  const GenereateNoTrans = async () => {
    const noawal = periode.toString();
    const notransaksiwal = noawal.substring(2, 6); 

    try {
      const response = await api.get(`/api/transaksi/getnotransaksiusp/${notransaksiwal}`);

      if (response.status === 200 && response.data.notransaksi) {
        const lastTrans = response.data.notransaksi.toString();

        // Ambil 4 digit terakhir sebagai nomor urut
        const lastSeq = parseInt(lastTrans.slice(-4)) || 0;
        const nextSeq = (lastSeq + 1).toString().padStart(4, "0");

        // Format: 4 digit periode + 4 digit urut
        const notransaksi = notransaksiwal + nextSeq;
        return notransaksi;
      } else {
        // default kalau belum ada
        return notransaksiwal + "0001";
      }
    } catch (error) {
      return notransaksiwal + "0001"; 
    }
  };

  // === Generate NoTrans Hariraya ===
  const GenerateNoTransHariraya = async () => {
    const noawal = periode.toString(); 
    const notransaksiwal = noawal.substring(2, 6); // contoh: "2509"

    try {
      const response = await api.get(`/api/transaksi/getnotransaksihariraya/${notransaksiwal}`);
      if (response.status === 200) {
        let lastTrans = response.data.notransaksi
          ? response.data.notransaksi.toString()
          : "";

        // Ambil 6 digit terakhir (urutan)
        let noindektrans =
          lastTrans.length >= 10 ? lastTrans.substring(4, 10) : "000000";
        let noindextransnext = (parseInt(noindektrans) || 0) + 1;

        // Format: 4 digit periode + 6 digit urut (total 10 digit)
        const notransaksi =
          notransaksiwal + noindextransnext.toString().padStart(6, "0");

        console.log("Generated Hariraya NoTrans:", notransaksi);
        return notransaksi;
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        const notransaksi = notransaksiwal + "000001";
        console.log("Default Hariraya NoTrans:", notransaksi);
        return notransaksi;
      } else {
        console.error("Error Generate Hariraya:", error);
        // fallback default supaya tetap ada nilai
        return notransaksiwal + "000001";
      }
    }
  };

  const GenerateNoTransAngsuran = async () => {
    const noawal = periode.toString();
    const notransaksiwal = noawal.substring(2, 6); // contoh: "2509"

    try {
      const response = await api.get(`/api/transaksi/getnotransaksiangsur/${notransaksiwal}`);
      if (response.status === 200) {
        let lastTrans = response.data.notransaksi;

        let noindektrans = lastTrans.length >= 10 ? lastTrans.substring(4, 10) : "000000";
        let noindextransnext = (parseInt(noindektrans) || 0) + 1;

        const notransaksi =
          notransaksiwal + noindextransnext.toString().padStart(6, "0");

        return notransaksi;
      } else {
        // kalau response kosong, pakai default
        return notransaksiwal + "000001";
      }
    } catch (error) {      
      // fallback nomor default supaya tidak undefined
      return notransaksiwal + "000001";
    }
  };

  // === Generate NoTrans Voucher ===
  const GenerateNoTransVoucher = async () => {
    const noawal = periode.toString(); 
    const notransaksiwal = noawal.substring(2, 6); // contoh: "2509"

    try {
      const response = await api.get(`/api/transaksi/getnotransaksivoucher/${notransaksiwal}`);
      if (response.status === 200) {
        const lastTrans = response.data.notransaksi ;
        // Ambil 6 digit terakhir (urutan)
        let noindektrans =
          lastTrans.length >= 10 ? lastTrans.substring(4, 10) : "000000";
        let noindextransnext = (parseInt(noindektrans) || 0) + 1;

        // Format: 4 digit periode + 6 digit urut
        const notransaksi =
          notransaksiwal + noindextransnext.toString().padStart(6, "0");
        return notransaksi;
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        const notransaksi = notransaksiwal + "000001";
        console.log("Default Voucher NoTrans:", notransaksi);
        return notransaksi;
      } else {
        console.error("Error Generate Voucher:", error);
        // fallback default supaya tetap ada nilai
        return notransaksiwal + "000001";
      }
    }
  };

  // Generated Untuk Manasuka
  const generateNoTransManasuka = async () => {
    const noawal = periode.toString();
    const notransaksiwal = noawal.substring(2, 6); // Nomor awal untuk Manasuka

    try {
      const response = await api.get(
        `/api/transaksi/getnotransaksimanasuka/${notransaksiwal}`
      );
      if (response.status === 200 && response.data.notransaksi) {
        const lastNoTransaksi = response.data.notransaksi
          ? response.data.notransaksi.toString()
          : "";
        if (!lastNoTransaksi || lastNoTransaksi.length < 9) {
          return notransaksiwal + "000001";
        }
        const noindextransnext = parseInt(lastNoTransaksi.substring(5, 10)) + 1;
        return notransaksiwal + noindextransnext.toString().padStart(6, "0");
      }
    } catch (error) {
      console.error("Error fetching Manasuka transaction number:", error);
    }
    return notransaksiwal + "000001"; // Jika terjadi error atau tidak ada transaksi sebelumnya
  };

  const handleReset = async() => {    
    const noTransaksinext = await GenereateNoTransUmum();
    setFormData(prev =>({
      tanggal: prev.tanggal,
      noTransaksi: noTransaksinext,
      noAnggota: "",
      nama: "",
      unitkerja: "",
      kdunitkerja: "0",
      sapokok: "0",
      sawajib: "0",
      samanasuka: "0",
      sahariraya: 0,
      savoucher: 0,
      noTransaksiUmum: "",
      pokok: "0",
      wajib: "0",
      manasuka: "0",
      debet: "0",
      kredit: "0",
      hariraya: 0,
      voucher: 0,
      noTransPiutang: {
        unitD: "",
        unitC: "",
        unitA: "",
      },
      sisaPiutang: {
        unitD: "0",
        unitC: "0",
        unitA: "0",
      },
      totalJasa: {
        unitD: "0",
        unitC: "0",
        unitA: "0",
      },
      totalGermen: {
        unitD: "0",
        unitC: "0",
        unitA: "0",
      },
      angsuran: {
        unitD: "0",
        unitC: "0",
        unitA: "0",
      },
      jasa: {
        unitD: "0",
        unitC: "0",
        unitA: "0",
      },
      germen: {
        unitD: "0",
        unitC: "0",
        unitA: "0",
      },
      total: "",
    }));  
  };

  // Saat Lost Focus No. Anggota
  const handleBlur = async () => {
    let dataAnggota;
    let saldosimpanan;
    let saldomanasuka;
    let saldohariraya;
    let saldovoucher;
    let saldopinjaman;
    
    // No Anggota //
    try {
      const response = await api.get(`/api/anggota/${formData.noAnggota}`);
      dataAnggota = response.data;
      // Untuk Mengambil Saldo Simpanan Saham //
      try {
        const response2 = await api.get(`/api/transaksi/saldosimpsaham/${periode}/${formData.noAnggota}`);
        saldosimpanan = response2.data;
      } catch (error) {
        console.error("Error during request:", error.message);
      }

      // Untuk Mengambil Saldo Pinjaman Piutang,Jasa Dan Germen //
      try {                                         
        const response = await api.get(`/api/piutang/findsaldo_jpg/${periode}/${formData.noAnggota}`);        
        saldopinjaman = response.data;
      } catch (error) {
        console.error("Error during request:", error.message);
      }

      // Untuk Saldo Simpanan Manasuka //
      try {
        const response = await api.get(`/api/transaksi/saldosimpananmanasuka/${periode}/${formData.noAnggota}`);
        saldomanasuka = response.data;
      } catch (error) {
        console.error("Error during request:", error.message);
      }

      // Untuk Saldo Simpanan Hari Raya //
      try {
        const response = await api.get(`/api/transaksi/saldosimphariraya/${periode}/${formData.noAnggota}`);
        saldohariraya = response.data;
      } catch (error) {
        console.error("Error during request:", error.message);
      }

      // Untuk Saldo Simpanan Voucher //
      try {
        const response = await api.get(`/api/transaksi/saldosimpvoucher/${periode}/${formData.noAnggota}`);
        saldovoucher = response.data;
      } catch (error) {
        console.error("Error during request:", error.message);
      }

      try {
        const response = await api.get(`/api/transaksi/getnotransaksiumum/${periode}/${formData.noAnggota}`
        );
        saldovoucher = response.data;
      } catch (error) {
        console.error("Error during request:", error.message);
      }

      const updatedFormData = {
        ...formData,
      };

      if (dataAnggota) {
        updatedFormData.nama = dataAnggota.nama;
        updatedFormData.kdunitkerja = dataAnggota.kodeuk;
        updatedFormData.unitkerja = dataAnggota.unitkerja;
      }
      if (saldosimpanan) {
        updatedFormData.sapokok = `${saldosimpanan.simppokok}`;
        updatedFormData.sawajib = `${saldosimpanan.simpwajib}`;
      }
      if (saldopinjaman) {
        const units = [
          {kode: "A", saldo: saldopinjaman.sldunit_a},
          {kode: "B", saldo: saldopinjaman.sldunit_b},
          {kode: "C", saldo: saldopinjaman.sldunit_c}
        ];
        const defaultResponse = { data: { data: { norealisasi: "", nilaiangsur: 0 } } };

        const result = await Promise.all(
          units.map(({kode, saldo}) => {
            if(saldo > 0){
              return api.get(`/api/piutang/getpiutang?kodepinjaman=${kode}&noanggota=${formData.noAnggota}`);
            } else {
              return Promise.resolve(defaultResponse);
            }
          }  
        ));
              
        const [datapiutangA, datapiutangB, datapiutangC] = result;
        updatedFormData.noTransPiutang = {
          unitD:datapiutangA?.data.data.norealisasi??"",
          unitC:datapiutangB?.data.data.norealisasi??"",
          unitA:datapiutangC?.data.data.norealisasi??"",
        };  
        /*updatedFormData.angsuran = {
          unitD: datapiutangA?.data.data.nilaiangsur??0,
          unitC: datapiutangB?.data.data.nilaiangsur??0,
          unitA: datapiutangC?.data.data.nilaiangsur??0,
        };*/
        updatedFormData.sisaPiutang = {
          unitD: saldopinjaman.sldunit_a,
          unitC: saldopinjaman.sldunit_b,
          unitA: saldopinjaman.sldunit_c,
        };
        updatedFormData.totalJasa = {
          unitD: saldopinjaman.sldjasa_a,
          unitC: saldopinjaman.sldjasa_b,
          unitA: saldopinjaman.sldjasa_c,
        };
        updatedFormData.totalGermen = {
          unitD: saldopinjaman.sldgermen_a,
          unitC: saldopinjaman.sldgermen_b,
          unitA: saldopinjaman.sldgermen_c,
        };
      }
      if (saldomanasuka) {
        updatedFormData.samanasuka = saldomanasuka.saldoakh;
      }
      if (saldohariraya) {
        updatedFormData.sahariraya = saldohariraya.saldoakh;
      }
      if (saldovoucher) {
        updatedFormData.savoucher = saldovoucher.saldoakh;
      }
      setFormData(updatedFormData);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          setFormData(resetFormData);
        } else {
          console.error("An error occurred:", error.response.status);
        }
      } else if (error.request) {
        console.error("No response from server");
      } else {
        console.error("Error during request:", error.message);
      }
    }
  };

  // Fungsi untuk menghitung total angsuran, jasa, dan germen

  useEffect(() => {
    if (formData.noAnggota !== prevNoAnggota) {
      setPrevNoAnggota(formData.noAnggota);

      setFormData((prev) => ({
        ...prev,
        pokok: "0",
        wajib: "0",
        manasuka: "0",
        hariraya: "0",
        voucher: "0",
      }));
    }
  }, [formData.noAnggota, prevNoAnggota]);

  useEffect(() => {
    const hitungTotal = (field) => {
      return Object.values(formData[field] || {}).reduce(
        (acc, val) => acc + parseNumber(val),
        0
      );
    };
    const totalSum = 
    parseNumber(formData.pokok || 0) +
    parseNumber(formData.wajib || 0) +
    parseNumber(formData.manasuka || 0) +
    parseNumber(formData.hariraya || 0) +
    parseNumber(formData.voucher || 0);

    const totalAngsuran = hitungTotal("angsuran");
    const totalJasa = hitungTotal("jasa");
    const totalGermen = hitungTotal("germen");

    setTotal({      
      angsuran: totalAngsuran,
      jasa: totalJasa,
      germen: totalGermen,
      keseluruhan: totalSum + totalAngsuran + totalJasa + totalGermen,
    });
  }, [formData,  
  ]);

  //Proses Penyimpanan
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.noTransaksi || formData.noTransaksi.trim() === "") {
      alert("No. Transaksi wajib diisi!");
      return;
    }

    if (!formData.noAnggota || formData.noAnggota.trim() === "") {
      alert("No. Anggota wajib diisi!");
      return;
    }

    const date = new Date(formData.tanggal);
    const yyyymm = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}`;
  
    if (yyyymm !== periode) {
      alert(`Tanggal transaksi tidak sesuai dengan periode ${periode}`);      
      handleReset();
      return;
    }

    try {

      // Simpanan USP
      if(parseFloat(formData.pokok) + parseFloat(formData.wajib) > 0 ){
        dataSimpUSP.tanggal = formData.tanggal;
        dataSimpUSP.notransaksi = await GenereateNoTrans() || ""; //formData.noTransaksi;
        dataSimpUSP.noanggota = formData.noAnggota;
        dataSimpUSP.nama = formData.nama;
        dataSimpUSP.sapokok = formData.sapokok;
        dataSimpUSP.sawajib =  formData.sawajib;
        dataSimpUSP.spokok  = formData.pokok;
        dataSimpUSP.swajib = formData.wajib;  
        dataSimpUSP.notransumum = formData.noTransaksi;  
        dataSimpUSP.postagihan = "1";      
        await api.post('/api/transaksi/simpananusp', dataSimpUSP);
      }

      // Siapkan data json Simpanan Manasuka
      if (parseFloat(formData.manasuka) > 0) {
        dataSimpManasuka.tgltransak = formData.tanggal || "";
        dataSimpManasuka.notransaksi = await generateNoTransManasuka() || "";
        dataSimpManasuka.noanggota = formData.noAnggota || "";
        dataSimpManasuka.kdtrans = formData.kdtrans || "1";
        dataSimpManasuka.kredit = `${parseFloat(formData.manasuka) || 0}`;
        dataSimpManasuka.saldoawl = `${parseFloat(formData.samanasuka) || 0}`;
        dataSimpManasuka.saldo = `${(parseFloat(formData.samanasuka) || 0) + (parseFloat(formData.manasuka) || 0)}`;
        dataSimpManasuka.kduser = kode;
        dataSimpManasuka.notransumum = formData.noTransaksi || "";
        await api.post("/api/transaksi/simpananmanasuka", dataSimpManasuka);
      }

      // Siapkan data jsonSimpanan Hari Raya
      if (parseFloat(formData.hariraya) > 0) {
        dataSimpHariRaya.tgltransak = formData.tanggal || "";
        dataSimpHariRaya.notransaksi = await GenerateNoTransHariraya() || "";
        dataSimpHariRaya.noanggota = formData.noAnggota || "";
        dataSimpHariRaya.kdtrans = formData.kdtrans || "1";
        dataSimpHariRaya.kredit = `${parseFloat(formData.hariraya)}` || "0"; 
        dataSimpHariRaya.saldoawl = `${parseFloat(formData.sahariraya)}` || "0";
        dataSimpHariRaya.saldo = `${parseFloat(formData.sahariraya) + parseFloat(formData.hariraya)}` || "0";
        dataSimpHariRaya.notransumum = formData.noTransaksi || "";
        dataSimpHariRaya.kduser = kode;
        await api.post("/api/transaksi/simpananhariraya", dataSimpHariRaya);
      }

      // Siapkan data json Simpanan Voucher
      if (parseFloat(formData.voucher) > 0) {
        dataSimpVoucher.tgltransak = formData.tanggal || "";
        dataSimpVoucher.notransaksi = await GenerateNoTransVoucher() || "";
        dataSimpVoucher.noanggota = formData.noAnggota || "";
        dataSimpVoucher.kdtrans = "1";
        dataSimpVoucher.kredit = isNaN(parseFloat(formData.voucher)) ? "0" : `${parseFloat(formData.voucher)}`;
        dataSimpVoucher.notransumum = formData.noTransaksi || "";
        await api.post("/api/transaksi/simpananvoucher", dataSimpVoucher);
      }      

      // Siapkan data json Angsuran USP dengan model terbaru
      const units = [
        { key:"unitD", kodeDefault : "A"},        
        { key:"unitC", kodeDefault : "B"},        
        { key:"unitA", kodeDefault : "C"},        
      ]
      for (const unit of units) {
        const angsuranValue = parseNumber(formData.angsuran[unit.key]);
        const jasaValue = parseNumber(formData.jasa[unit.key]);
        const germenValue = parseNumber(formData.germen[unit.key]);
        
        if (angsuranValue + jasaValue + germenValue > 0) {
          const dataAnsuran2 = {
            tanggal: formData.tanggal,
            noanggota: formData.noAnggota,
            kodepiutang: unit.kodeDefault, 
            postagihan: 1, 
            norealisasi: formData.noTransPiutang[unit.key] || "-",
            saldo_awal: parseNumber(formData.sisaPiutang[unit.key]),
            angsuran: angsuranValue,
            jasa: parseNumber(formData.jasa[unit.key]),
            germen: parseNumber(formData.germen[unit.key]),
            userentri: kode,
            notransumum: formData.noTransaksi
          };
          const response = await api.post(`/api/piutang/angsuranpinjaman`, dataAnsuran2); 
          if(response.status === 201 || response.status === 200){
            console.log("Angsuran Pinjaman berhasil disimpan");
          } else {
            console.error("Gagal menyimpan angsuran pinjaman");
          }
        }  
      }  
      
      // Simpan (Record) ke Transaksi Umum.
      const dataUmum = {
        notransaksi: formData.noTransaksi,
        tgltransak: formData.tanggal,
        noanggota: formData.noAnggota,
        nama : formData.nama,
        kdunitkerja: formData.kdunitkerja,
        unitkerja: formData.unitkerja,
        spokok: parseNumber(formData.pokok),
        swajib: parseNumber(formData.wajib),
        smanasuka: parseNumber(formData.manasuka),
        shariraya: parseNumber(formData.hariraya),
        svoucher: parseNumber(formData.voucher),
        angsuran_d: parseNumber(formData.angsuran.unitD),
        angsuran_c: parseNumber(formData.angsuran.unitC),
        angsuran_a: parseNumber(formData.angsuran.unitA),
        jasa_d: parseNumber(formData.jasa.unitD),
        jasa_c: parseNumber(formData.jasa.unitC),
        jasa_a: parseNumber(formData.jasa.unitA),
        germen_d: parseNumber(formData.germen.unitD),
        germen_c: parseNumber(formData.germen.unitC),
        germen_a: parseNumber(formData.germen.unitA),
        user: kode,
        tglproses: new Date().toISOString(),
      };
      const response = await api.post(`/api/transaksi/transaksiumum`, dataUmum); 
      
      if (response.status === 201  || response.status === 200) {
        alert("Transaksi berhasil disimpan ✅");                
        TransaksiUmum(dataUmum);
        handleReset();
      } else {
        alert("Gagal menyimpan transaksi ❌");
      }
    } catch (error) {
      console.error("Error simpan transaksi umum:", error);
      alert("Terjadi kesalahan saat menyimpan transaksi");
    }
  };

  return (
    <div
      className="container mt-5"
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <div className="card card-info" style={{ width: "700px" }}>
        <div className="card-header">
          <h3 className="card-title">Transaksi Umum</h3>
        </div>
        <div className="card-body">
          {/* Bagian Atas */}
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">Tanggal</label>
            <div className="col-sm-3">
              <input
                type="date"
                className="form-control"
                name="tanggal"
                value={formData.tanggal}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">No. Transaksi</label>
            <div className="col-sm-3">
              <input
                type="text"
                className="form-control"
                name="noTransaksi"
                value={formData.noTransaksi}
                onChange={handleInputChange}
                readOnly
                disabled
                required
              />
            </div>
            <div className="col-auto">
              <button
                className="btn btn-primary"
                style={{ backgroundColor: "red", color: "white" }}
                onClick={GenereateNoTransUmum}
              >
                Click
              </button>
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">No. Anggota</label>
            <div className="col-sm-3">
              <input
                type="text"
                className="form-control"
                name="noAnggota"
                value={formData.noAnggota}
                onChange={handleInputChange} // Menyimpan input tanpa reset
                onBlur={handleBlur} // Reset hanya saat kehilangan fokus
                required
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">Nama</label>
            <div className="col-sm-9">
              <input
                type="text"
                className="form-control"
                name="nama"
                value={formData.nama}
                onChange={handleInputChange}
                readOnly
                disabled
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">Unit Kerja</label>
            <div className="col-sm-9">
              <input
                type="text"
                className="form-control"
                name="kode_uk"
                value={formData.unitkerja}
                onChange={handleInputChange}
                readOnly
                disabled
              />
            </div>
          </div>
          <hr />
          {/* Bagian Simpanan */}
          {/* Input Pokok */}
          <div className="form-group row">
            <div className="col-sm-12">
              <div className="row">
                <label className="col-sm-3 col-form-label font-weight-bold">
                  Pokok
                </label>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="sapokok"
                    value={formatNumber(formData.sapokok)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Pokok 1"
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="pokok"
                    value={formatNumber(formData.pokok)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Pokok"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group row">
            {/*Kolom untuk wajib (2 Input) */}
            <div className="col-sm-12">
              <div className="row">
                <label className="col-sm-3 col-form-label font-weight-bold">
                  Wajib
                </label>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="sawajib"
                    value={formatNumber(formData.sawajib)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="wajib"
                    value={formatNumber(formData.wajib)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group row">
            {/* Kolom untuk Manasuka (2 Input) */}
            <div className="col-sm-12">
              <div className="row">
                <label className="col-sm-3 col-form-label font-weight-bold">
                  Manasuka
                </label>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="manasuka"
                    value={formatNumber(formData.samanasuka)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Manasuka 1"
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="manasuka"
                    value={formatNumber(formData.manasuka)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Manasuka 2"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-12">
              <div className="row">
                <label className="col-sm-3 col-form-label font-weight-bold">
                  Hari Raya
                </label>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="hariraya"
                    value={formatNumber(formData.sahariraya)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Voucher 1"
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="hariraya"
                    value={formatNumber(formData.hariraya)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Voucher 2"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-12">
              <div className="row">
                <label className="col-sm-3 col-form-label font-weight-bold">
                  Voucher
                </label>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="voucher"
                    value={formatNumber(formData.savoucher)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Voucher 1"
                    readOnly
                    disabled
                  />
                </div>
                <div className="col-sm-3">
                  <input
                    type="text"
                    className="form-control"
                    name="voucher"
                    value={formatNumber(formData.voucher)}
                    onChange={handleInputChange}
                    style={{ textAlign: "right" }}
                    placeholder="Voucher 2"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Tabel 1 */}
          <table className="table table-bordered" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: "25%" }}>Unit</th>
                <th>Sisa Piutang</th>
                <th>Total Jasa</th>
                <th>Total Germen</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["unitD", "Unit D"],
                ["unitC", "Unit C"],
                ["unitA", "Unit A"],
              ].map((unit) => (
                <tr key={unit[0]}>
                  <td>{unit[1]}</td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`sisaPiutang.${unit[0]}`}
                      value={(
                        formData.sisaPiutang[unit[0]] || 0
                      ).toLocaleString("id-ID")}
                      style={{ textAlign: "right" }}
                      readOnly
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`totalJasa.${unit[0]}`}
                      value={(
                        formData.totalJasa[unit[0]] || 0
                      ).toLocaleString("id-ID")}
                      style={{ textAlign: "right" }}
                      readOnly
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`totalGermen.${unit[0]}`}
                      value={(
                        formData.totalGermen[unit[0]] || 0
                      ).toLocaleString("id-ID")}
                      style={{ textAlign: "right" }}
                      readOnly
                      disabled
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <table className="table table-bordered" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: "25%" }}>Unit</th>
                <th>Angsuran</th>
                <th>Jasa</th>
                <th>Germen</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["unitD", "Unit D"],
                ["unitC", "Unit C"],
                ["unitA", "Unit A"],
              ].map((unit) => (
                <tr key={unit[0]}>
                  <td>{unit[1]}</td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`angsuran.${unit[0]}`}
                      value={formatNumber(formData.angsuran[unit[0]])}
                      onChange={handleInputChange}
                      style={{ textAlign: "right" }}
                      readOnly={formData.sisaPiutang[unit[0]] === 0}
                      disabled={formData.sisaPiutang[unit[0]] === 0}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`jasa.${unit[0]}`}
                      value={formatNumber(formData.jasa[unit[0]])}
                      onChange={handleInputChange}
                      style={{ textAlign: "right" }}
                      readOnly={formData.sisaPiutang[unit[0]] === 0}
                      disabled={formData.sisaPiutang[unit[0]] === 0}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name={`germen.${unit[0]}`}
                      value={formatNumber(formData.germen[unit[0]])}
                      onChange={handleInputChange}
                      style={{ textAlign: "right" }}
                      readOnly={formData.sisaPiutang[unit[0]] === 0}
                      disabled={formData.sisaPiutang[unit[0]] === 0}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Bagian Total */}
          <div className="form-group row mt-3">
            <label className="col-sm-3 col-form-label">Total</label>
            <div className="col-sm-3">
              <input
                type="text"
                className="form-control"
                name="total"
                value={formatNumber(total.keseluruhan.toString())}
                readOnly
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={handleReset}>
            Batal
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransaksiUspUmum;